import { useEffect } from "react";

import { useSetAtom } from "jotai";

import { fieldGroupDataAtom } from "../atoms/fieldGroupAtoms";
import { useFieldGroupData } from "./useFieldGroupData";

export interface UseFieldGroupSyncParams {
  fieldGroup: string;
  isVisible: boolean;
}

/**

 * Multiple FieldGroupEditor instances exist simultaneously (one per field group),
 * but they all share the same fieldGroupDataAtom. We only sync when this instance's
 * modal is visible
 */
export function useFieldGroupSync({ fieldGroup, isVisible }: UseFieldGroupSyncParams) {
  const fieldGroupData = useFieldGroupData({ fieldGroup, isVisible });
  const setFieldGroupData = useSetAtom(fieldGroupDataAtom);

  useEffect(() => {
    // Only sync when visible and have data
    if (!isVisible || !fieldGroupData.data) {
      return;
    }

    setFieldGroupData(fieldGroupData.data);
  }, [fieldGroupData.data, isVisible, setFieldGroupData]);
}
